import { apiClient } from "./client";

const GetAll = () => {
  return apiClient
    .get("/Room");
}

const GetByKey = (id) => {
  return apiClient
    .get("/Room/GetById", {
      params: {
        'Key': id
      }
    });
}

const GetOverRoomByHotelStrctureId = (hotelStructureId) => {
  return apiClient
    .get("/Room/GetOverRoomByHotelStrctureId", {
      params: {
        'hotelStructureId': hotelStructureId
      }
    });
}

const RoomDropDown = () => {
  return apiClient
    .get("/Room/RoomDropDown");
}

const GetForUser = () => {
  return apiClient
    .get("/Room/GetForUser");
}

const GetRoomTypeDropDown = () => {
  return apiClient
    .get("/Room/GetRoomTypeDropDown")
}

const GetRoomTypeDropDownForRegistration = () => {
  return apiClient
    .get("/Room/GetRoomTypeDropDownForRegistration")
}

const SoftDelete = (id) => {
  return apiClient
    .delete("/Room", {
      params: {
        'Id': id
      }
    });
}

const Add = (data) => {
  return apiClient.post('/Room', {
    'roomNumber': data.roomNumber,
    'description': data.description,
    'floorId': data.floorId,
    'roomTypeKey': data.roomTypeKey,
    'bedCount': data.bedCount,
    'roomNumberCode': data.roomNumberCode
  }
  )
}

const Update = (data) => {
  return apiClient.put('/Room', {
    'roomNumber': data.roomNumber,
    'description': data.description,
    'roomTypeKey': data.roomTypeKey,
    'bedCount': data.bedCount,
    'isActive': data.isActive,
    'applayToAll': data.applayToAll,
    'roomNumberCode': data.roomNumberCode,
    'editReserves': data.editReserves
  }, {
    params: {
      'id': data.id
    }
  }
  )
}

const roomApi = {
  Add, Update, GetAll, GetByKey, RoomDropDown, GetForUser, GetRoomTypeDropDown, GetRoomTypeDropDownForRegistration, SoftDelete,
  GetOverRoomByHotelStrctureId
}
export default roomApi;